/*
* Project: LegalPlace assistant
* File: src/components/preview_row.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import LpOutput from '../logic/preview_render/angular_reader';
import { generateId1 } from './utils/misc';
import {
  lpGetVariableById, lpGetOptionById,
} from '../logic/re_index';
import { lpIdGetPure } from '../logic/global_getter';
import lpApp from '../app/lp_app';

class _PreviewRow extends Component {
  constructor(props) {
    super(props);

    // Getting all variable childs
    // Getting father
    const parentId = lpApp.indexes.grandpa.getFather(lpIdGetPure(props.idOut));

    if (parentId && lpApp.references.getOption(parentId).meta.type === 'repeated') {
      const repeatOptionId = lpApp.references.getOption(parentId).meta.repeatOption;
      const children = lpApp.ops.utils.getAllChildren(repeatOptionId);
      const variables = lpApp.ops.utils.getAllVariableChildren(children);

      this.view = new LpOutput(props.idOut, props.template, -1, variables);
    } else {
      this.view = new LpOutput(props.idOut, props.template);
    }


    this.data = [];
    // console.log(props.template);
    // console.log(this.view.id)
    this.view.compile();
    // this.rData = [];
    // console.log(this.view.variables);
  }

  componentWillMount() {
    this.my_key = generateId1(4);
    this.rData = this.view.variables.map(idx => this.props.getValue(idx));
    this.strings = { __html: this.view.draw(this.rData) };
    if (this.props.am_popup) {
      this.view = new LpOutput(this.props.idOut, this.props.template, this.props.var_to_hover);
      this.view.compile();
    }
  }

  shouldComponentUpdate(){
    let newString = JSON.stringify(this.view.variables.map(idx => this.props.getValue(idx)));

    if(newString === this.oldString){
        this.updateNumbers();
        return false;
    } else {
        this.oldString = newString
        return true
    }
  }

  componentDidUpdate() {
    this.updateNumbers();
  }

  updateNumbers = () => {
    if(this.props.lastView === true)
      this.props.updateNumbers();
  }

  render() {
    // console.time("render")
    this.rData = this.view.variables.map(idx => this.props.getValue(idx));
    // console.log(this.props.idOut, this.view.raw.search(/justify/g))
    this.view.compiled = this.view.compiled.replace(/text-align:justify/g, '');
    const strs = { __html: this.view.draw(this.rData) };
    const result = (
      <span ref="doc_row">
        {/* this.props.condition && */
          <span
            data-id={this.props.idOut}
            className="preview-row"
            dangerouslySetInnerHTML={strs}
          />}
      </span>
    );
    // console.timeEnd("render")
    return result;
  }
}

const mapStateToProps = (state, ownProps) => {
  const pText = state.views[ownProps.out];
  const conditionShow = true;
  let cId = ownProps.idOut;
  if (typeof cId === 'string') {
    [cId] = cId.split('_');
  }
  let a = lpGetOptionById(ownProps.idOut);
  if (typeof a === 'undefined') {
    // test
    if (state.document_state.state === 'continue') {
      if (lpApp.references.getOption(cId) && lpApp.references.getOption(cId).meta.type === 'checkbox') {
        a = {
          value: (state.loadedOvc && state.loadedOvc.cF && state.loadedOvc.cF[ownProps.idOut])
            ? (state.loadedOvc.cF[ownProps.idOut])
            : (!((lpApp.references.getOption(cId).meta.type === 'radio') || (lpApp.references.getOption(cId).meta.type === 'checkbox'))),
        };
      } else {
        a = {
          value: (state.loadedOvc && state.loadedOvc.oF && state.loadedOvc.oF[ownProps.idOut])
            ? (state.loadedOvc.oF[ownProps.idOut])
            : (!((lpApp.references.getOption(cId).meta.type === 'radio') || (lpApp.references.getOption(cId).meta.type === 'checkbox'))),
        };
      }
    }
  }
  if (lpApp.references.getOption(cId) && (lpApp.references.getOption(cId).meta.type === 'radio' || lpApp.references.getOption(cId).meta.type === 'checkbox')) {
    if (typeof a === 'undefined') a = false;
    else a = a.value;
  } else {
    a = true;
  }
  // a = true;
  return {
    condition: conditionShow && a,
    template: pText,
    var_to_hover: state.input_context.variable,
    v: state.input_context.variable,
    getValue: (id) => {
      let result = '';
      if (typeof lpGetVariableById(id) !== 'undefined') {
        const { value } = lpGetVariableById(id);
        // let value = toString(lpGetVariableById(id).value);
        result = value.replace(/<br>/g, '\n').replace(/</g, '&lt;').replace(/\n/g, '<br>');
      } else {
        // TODO: test the continue foirst
        result = state.loadedOvc && state.loadedOvc.vF ? state.loadedOvc.vF[id] : '';
      }
      return result;
    },
  };
};

const PreviewRow = connect(mapStateToProps)(_PreviewRow);

export default PreviewRow;



// WEBPACK FOOTER //
// ./src/components/preview_row.js